// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NewProgressBar_wrapper__31xM6","innerProgressBar":"NewProgressBar_innerProgressBar__mU016","children":"NewProgressBar_children__3gHX2"};